import {
  createRouter,
  createWebHistory
} from 'vue-router'
import HomeView from '../views/HomeView.vue'

import FrontendLayout from '@/layouts/Frontend.vue'
import AgenteServiceView from '@/views/AgenteServiceView.vue'

import AgentInfo from '@/views/AgenteServiec/AgentInfoView.vue'
import EditNameTh from '@/components/agenteservice/EditNameTh.vue'
import EditNameEng from '@/components/agenteservice/EditNameEng.vue'
import EditMobilePhone from '@/components/agenteservice/EditMobilePhone.vue'
import EditEmail from '@/components/agenteservice/EditEmail.vue'
import EditBankAccount from '@/components/agenteservice/EditBankAccount.vue'
import EditVat from '@/components/agenteservice/EditVat.vue'

import AgentAddress from '@/views/AgenteServiec/AgentAddress.vue'
import EditAddress from '@/components/agenteservice/EditAddress.vue'

import FinishAgentInfoView from '@/views/AgenteServiec/FinishAgentInfoView.vue'
import AgentHistoryView from '@/views/AgenteServiec/AgentHistoryView.vue'
import HistoryDetail from '@/components/agenteservice/HistoryDetail.vue'

import ChangeBranchView from '@/views/AgenteServiec/ChangeBranchView.vue'
import FinishAgentBranch from '@/components/agenteservice/FinishAgentBranch.vue'

import ManagerBranchView from '@/views/AgenteServiec/ManagerBranchView.vue'
import FinishManagerBranch from '@/components/agenteservice/FinishManagerBranch.vue'

import TransferAgentView from '@/views/AgenteServiec/TransferAgentView.vue'
import FinishTranferAgent from '@/components/agenteservice/FinishTranferAgent.vue'

import AssignPositionView from '@/views/AgenteServiec/AssignPositionView.vue'
import FinishAssignPosition from '@/components/agenteservice/FinishAssignPosition.vue'

import ChangePositionView from '@/views/AgenteServiec/ChangePositionView.vue'
import FinishChangePosition from '@/components/agenteservice/FinishChangePosition.vue'

import TranferWorkView from '@/views/AgenteServiec/TranferWorkView.vue'
import FinishTranferWork from '@/components/agenteservice/FinishTranferWork.vue'

import PrintCardView from '@/views/AgenteServiec/PrintCardView.vue'
import FinishPrintCard from '@/components/agenteservice/FinishPrintCard.vue'

import RequestCertView from '@/views/AgenteServiec/RequestCertView.vue'

import ResignationView from '@/views/AgenteServiec/ResignationView.vue'
import FinishResignation from '@/components/agenteservice/FinishResignation.vue'
import FinishCertTH from '@/components/agenteservice/FinishCertTH.vue'
import FinishCertEng from '@/components/agenteservice/FinishCertEng.vue'
import FinishCertEng2Year from '@/components/agenteservice/FinishCertEng2Year.vue'
import FinishCertEng1Year from '@/components/agenteservice/FinishCertEng1Year.vue'
import FinishEmailMobileView from '@/views/AgenteServiec/FinishEmailMobileView.vue'

import CheckOTP from '@/components/agenteservice/CheckOTP.vue'

import SocialMediaInfo from '@/views/AgenteServiec/SocialMediaInfoView.vue'
import EditLineID from '@/components/agenteservice/EditLineID.vue'
import EditFacebook from '@/components/agenteservice/EditFacebook.vue'
import EditTikTok from '@/components/agenteservice/EditTiktok.vue'
import EditInstagram from '@/components/agenteservice/EditIG.vue'
import EditX from '@/components/agenteservice/EditX.vue'
import FinishSocialMediaInfoView from '../views/AgenteServiec/FinishSocialMediaInfoView.vue'

import ProspectServiceView from '../views/ProspectServiceView.vue'
import ProspectHistoryView from '../views/ProspectService/ProspectHistoryView.vue'

import Verification from '../views/ProspectService/VerificationView.vue'
import SendAdditionalDocView from '../views/ProspectService/SendAdditionalDocView.vue'
import OnlineAgentRegisterView from '../views/ProspectService/OnlineAgentRegisterView.vue'
import FinishVerificationView from '../views/ProspectService/FinishVerificationView.vue'
import FinishSendAdditionalDocView from '../views/ProspectService/FinishSendAdditionalDocView.vue'
import ProspectHistoryDetail from '../components/prospectservice/ProspectHistoryDetail.vue'

import AgentRenewLicenseView from '../views/AgenteServiec/AgentRenewLicenseView.vue'
import PreviewAgentRenewLicense from '../components/agenteservice/AgentRenewLicensePreview.vue'
import Tc7Certification from '../components/agenteservice/AgentRenewLicenseTc7Certification.vue'
import UploadFileAgentRenewLicense from '../components/agenteservice/AgentRenewLicenseUploadFile.vue'
import ReviewDraftAgentRenewLicense from '../components/agenteservice/AgentRenewLicenseReviewDraft.vue'
import OTPVerifyAgentRenewLicense from '../components/agenteservice/AgentRenewLicenseVerifyOTP.vue'
import CheckPaymentAgentRenewLicense from '../components/agenteservice/AgentRenewLicenseCheckPayment.vue'
import FinishAgentRenewLicense from '../views/AgenteServiec/FinishAgentRenewLicense.vue'
import AgentRenewLicenseAdditionalDocView from '../views/AgenteServiec/AgentRenewLicenseAdditionalDocView.vue'
import FinishSendAgentRenewLicenseAdditionalDoc from '../views/AgenteServiec/FinishSendAgentRenewLicenseAdditionalDoc.vue'

// ส่งเอกสารเพิ่มเติม
import ChangeNameEN from '../views/AgenteServiec/AdditionalDocs/ChangeNameENView.vue'
import ChangeAddr from '../views/AgenteServiec/AdditionalDocs/ChangeAddrView.vue'
import ChangeAccBank from '../views/AgenteServiec/AdditionalDocs/ChangeAccBankView.vue'
import ChangeVat from '../views/AgenteServiec/AdditionalDocs/ChangeVatView.vue'
import AppointOperationExecutive from '../views/AgenteServiec/AdditionalDocs/AppointOperationExecutiveView.vue'
import OperationExecutivePromotion from '../views/AgenteServiec/AdditionalDocs/OperationExecutivePromotionView.vue'
import OperationExecutiveDowngrade from '../views/AgenteServiec/AdditionalDocs/OperationExecutiveDowngradeView.vue'
import TransferSubAgentOperationExecutive from '../views/AgenteServiec/AdditionalDocs/TransferSubAgentOperationExecutiveView.vue'
import BranchTransferOperationExecutive from '../views/AgenteServiec/AdditionalDocs/BranchTransferOperationExecutiveView.vue'
import BranchTransferOperationAgent from '../views/AgenteServiec/AdditionalDocs/BranchTransferOperationAgentView.vue'
import TransferPerformance from '../views/AgenteServiec/AdditionalDocs/TransferPerformanceView.vue'
import ReqAgentCertTH from '../views/AgenteServiec/AdditionalDocs/ReqAgentCertTHView.vue'
import ReqAgentCertENNoIncome from '../views/AgenteServiec/AdditionalDocs/ReqAgentCertENNoIncomeView.vue'
import ReqAgentCertENIncome2Years from '../views/AgenteServiec/AdditionalDocs/ReqAgentCertENIncome2YearsView.vue'
import ReqAgentCertENIncomeCurrent from '../views/AgenteServiec/AdditionalDocs/ReqAgentCertENIncomeCurrentView.vue'
import ReqAgentBusinessCard from '../views/AgenteServiec/AdditionalDocs/ReqAgentBusinessCardView.vue'
import ReqAgentResignation from '../views/AgenteServiec/AdditionalDocs/ReqAgentResignationView.vue'

import FinishAdditionalDocsPage from '../components/agenteservice/FinishAdditionalDocsPage.vue'

import BuildingAccessCard from '../views/AgenteServiec/BuildingAccessCardView.vue'
import CardRequestType from '../components/agenteservice/BuildingAccessCard/CardRequestType.vue'
import BACUploadFile from '../components/agenteservice/BuildingAccessCard/BACUploadFile.vue'
import BACPayment from '../components/agenteservice/BuildingAccessCard/BACPayment.vue'
import BACSuccess from '../components/agenteservice/BuildingAccessCard/BACSuccess.vue'
import BACAdditionalDoc from '../views/AgenteServiec/BACAdditionalDocView.vue'

const routes = [{
    path: '/',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'home',
      component: HomeView
    }],
    meta: {
      title: 'หน้าหลัก'
    }
  },
  {
    path: '/AgenteService',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'AgenteService',
      component: AgenteServiceView
    }],
    meta: {
      title: 'AgenteService'
    }
  },
  {
    path: '/AgentInfo',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'AgentInfo',
      component: AgentInfo
    }],
    meta: {
      title: 'AgenteService - AgentInfo'
    }
  },
  {
    path: '/EditNameTh',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'EditNameTh',
      component: EditNameTh
    }],
    meta: {
      title: 'AgenteService - เปลี่ยนแปลงชื่อ - นามสกุล (ภาษาไทย)'
    }
  },
  {
    path: '/EditNameEng',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'EditNameEng',
      component: EditNameEng
    }],
    meta: {
      title: 'AgenteService - เปลี่ยนแปลงชื่อ - นามสกุล (ภาษาอังกฤษ)'
    }
  },
  {
    path: '/EditMobilePhone',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'EditMobilePhone',
      component: EditMobilePhone
    }],
    meta: {
      title: 'AgenteService - เปลี่ยนแปลงเบอร์มือถือ'
    }
  },
  {
    path: '/EditEmail',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'EditEmail',
      component: EditEmail
    }],
    meta: {
      title: 'AgenteService - เปลี่ยนแปลงอีเมล'
    }
  },
  {
    path: '/AgentAddress',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'AgentAddress',
      component: AgentAddress
    }],
    meta: {
      title: 'AgenteService - เปลี่ยนแปลงที่อยู่'
    }
  },
  {
    path: '/EditAddress',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'EditAddress',
      component: EditAddress
    }],
    meta: {
      title: 'AgenteService - เปลี่ยนแปลงที่อยู่'
    }
  },
  {
    path: '/EditBankAccount',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'EditBankAccount',
      component: EditBankAccount
    }],
    meta: {
      title: 'AgenteService - เปลี่ยนแปลงเลขที่บัญชีธนาคาร'
    }
  },
  {
    path: '/EditVat',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'EditVat',
      component: EditVat
    }],
    meta: {
      title: 'AgenteService - ขอบันทึก VAT'
    }
  },
  {
    path: '/FinishAgentInfoView',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishAgentInfoView',
      component: FinishAgentInfoView
    }],
    meta: {
      title: 'FinishAgentInfoView'
    }
  },
  {
    path: '/AgentHistory',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'AgentHistoryView',
      component: AgentHistoryView
    }],
    meta: {
      title: 'AgenteService - ประวัติการแก้ไข'
    }
  },
  {
    path: '/HistoryDetail',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'HistoryDetail',
      component: HistoryDetail
    }],
    meta: {
      title: 'AgenteService - รายละเอียดการแก้ไข'
    }
  }, {
    path: '/ChangeBranch',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'ChangeBranchView',
      component: ChangeBranchView
    }],
    meta: {
      title: 'AgenteService - แจ้งยายสาขา'
    }
  },
  {
    path: '/FinishAgentBranch',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishAgentBranch',
      component: FinishAgentBranch
    }],
    meta: {
      title: 'AgenteService - ตรวจสอบข้อมูลที่ขอเปลี่ยนแปลง'
    }
  },
  {
    path: '/ManagerChangeBranch',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'ManagerBranchView',
      component: ManagerBranchView
    }],
    meta: {
      title: 'AgenteService - แจ้งยายสาขา (หน่วยดำเนินการ)'
    }
  },
  {
    path: '/FinishManagerBranch',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishManagerBranch',
      component: FinishManagerBranch
    }],
    meta: {
      title: 'AgenteService - ตรวจสอบข้อมูลที่ขอเปลี่ยนแปลง'
    }
  },
  {
    path: '/TransferAgent',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'TransferAgentView',
      component: TransferAgentView
    }],
    meta: {
      title: 'AgenteService - ขอโอนตัวแทนใต้สังกัด (หน่วยดำเนินการ)'
    }
  },
  {
    path: '/FinishTranferAgent',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishTranferAgent',
      component: FinishTranferAgent
    }],
    meta: {
      title: 'AgenteService - ตรวจสอบข้อมูลที่ขอเปลี่ยนแปลง'
    }
  },
  {
    path: '/AssignPosition',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'AssignPositionView',
      component: AssignPositionView
    }],
    meta: {
      title: 'AgenteService - ขอแต่งตั้งตำแหน่ง (หน่วยดำเนินการ)'
    }
  },
  {
    path: '/FinishAssignPosition',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishAssignPosition',
      component: FinishAssignPosition
    }],
    meta: {
      title: 'AgenteService - ตรวจสอบข้อมูลที่ขอเปลี่ยนแปลง'
    }
  },
  {
    path: '/ChangePosition',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'ChangePositionView',
      component: ChangePositionView
    }],
    meta: {
      title: 'AgenteService - ขอเปลี่ยนแปลงตำแหน่ง (ผู้บริหารหน่วยดำเนินการ)'
    }
  },
  {
    path: '/FinishChangePosition',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishChangePosition',
      component: FinishChangePosition
    }],
    meta: {
      title: 'AgenteService - ตรวจสอบข้อมูลที่ขอเปลี่ยนแปลง'
    }
  },
  {
    path: '/TranferWork',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'TranferWorkView',
      component: TranferWorkView
    }],
    meta: {
      title: 'AgenteService - ขอโอนผลงาน'
    }
  },
  {
    path: '/FinishTranferWork',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishTranferWork',
      component: FinishTranferWork
    }],
    meta: {
      title: 'AgenteService - ตรวจสอบข้อมูลที่ขอเปลี่ยนแปลง'
    }
  },
  {
    path: '/PrintCard',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'PrintCardView',
      component: PrintCardView
    }],
    meta: {
      title: 'AgenteService - ขอพิมพ์นามบัตร'
    }
  },
  {
    path: '/FinishPrintCard',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishPrintCard',
      component: FinishPrintCard
    }],
    meta: {
      title: 'AgenteService - ตรวจสอบข้อมูลที่ขอเปลี่ยนแปลง'
    }
  },
  {
    path: '/Resignation',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'ResignationView',
      component: ResignationView
    }],
    meta: {
      title: 'AgenteService - ขอลาออก'
    }
  },
  {
    path: '/RequestCert',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'RequestCertView',
      component: RequestCertView
    }],
    meta: {
      title: 'AgenteService - ขอหนังสือรับรองการทำงาน'
    }
  },
  {
    path: '/FinishResignation',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishResignation',
      component: FinishResignation
    }],
    meta: {
      title: 'AgenteService - ตรวจสอบข้อมูลที่ขอลาออก'
    }
  },
  {
    path: '/FinishCertTH',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishCertTH',
      component: FinishCertTH
    }],
    meta: {
      title: 'AgenteService - หนังสือรับรองการทำงานภาษาไทย'
    }
  },
  {
    path: '/FinishCertEng',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishCertEng',
      component: FinishCertEng
    }],
    meta: {
      title: 'ขอหนังสือรับรองการทำงานภาษาอังกฤษ แบบไม่ระบุรายได้'
    }
  },
  {
    path: '/FinishCertEng2Year',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishCertEng2Year',
      component: FinishCertEng2Year
    }],
    meta: {
      title: 'ขอหนังสือรับรองการทำงานภาษาอังกฤษ (ระบุรายได้ของปีนี้ และปีก่อนหน้า 2 ปี)'
    }
  },
  {
    path: '/FinishCertEng1Year',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishCertEng1Year',
      component: FinishCertEng1Year
    }],
    meta: {
      title: 'ขอหนังสือรับรองการทำงานภาษาอังกฤษ (ระบุรายได้เฉพาะของปีนี้ หรือปีก่อนหน้า 1 ปี)'
    }
  },
  {
    path: '/CheckOTP',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'CheckOTP',
      component: CheckOTP
    }],
    meta: {
      title: 'AgenteSerivce - ยืนยัน OTP'
    }
  },
  {
    path: '/FinishEmailMobileView',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishEmailMobileView',
      component: FinishEmailMobileView
    }],
    meta: {
      title: 'FinishEmailMobileView'
    }
  },
  {
    path: '/SocialMediaInfo',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'SocialMediaInfo',
      component: SocialMediaInfo
    }],
    meta: {
      title: 'AgenteService - เปลี่ยนแปลงข้อมูล Social Media'
    }
  },
  {
    path: '/SocialMediaInfo/EditLineID',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'EditLineID',
      component: EditLineID
    }],
    meta: {
      title: 'เปลี่ยนแปลง Line ID'
    }
  },
  {
    path: '/SocialMediaInfo/EditFacebook',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'EditFacebook',
      component: EditFacebook
    }],
    meta: {
      title: 'เปลี่ยนแปลง Facebook'
    }
  },
  {
    path: '/SocialMediaInfo/EditTikTok',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'EditTikTok',
      component: EditTikTok
    }],
    meta: {
      title: 'เปลี่ยนแปลง TikTok'
    }
  },
  {
    path: '/SocialMediaInfo/EditInstagram',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'EditInstagram',
      component: EditInstagram
    }],
    meta: {
      title: 'เปลี่ยนแปลง Instagram'
    }
  },
  {
    path: '/SocialMediaInfo/EditX',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'EditX',
      component: EditX
    }],
    meta: {
      title: 'เปลี่ยนแปลง X'
    }
  },
  {
    path: '/FinishSocialMediaInfoView',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishSocialMediaInfoView',
      component: FinishSocialMediaInfoView
    }],
    meta: {
      title: 'FinishSocialMediaInfoView'
    }
  },
  {
    path: '/ProspectService',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'ProspectService',
      component: ProspectServiceView
    }],
    meta: {
      title: 'ProspectService'
    }
  },
  {
    path: '/ProspectHistory',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'ProspectHistoryView',
      component: ProspectHistoryView
    }],
    meta: {
      title: 'ProspectService - ประวัติการแก้ไข'
    }
  },
  {
    path: '/Verification',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'Verification',
      component: Verification
    }],
    meta: {
      title: 'ยื่นตรวจสอบคุณสมบัติ'
    }
  },
  {
    path: '/SendAdditionalDoc',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'SendAdditionalDoc',
      component: SendAdditionalDocView
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม'
    }
  },
  {
    path: '/OnlineAgentRegister',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'OnlineAgentRegister',
      component: OnlineAgentRegisterView
    }],
    meta: {
      title: 'สมัครเป็นตัวแทนกรุงเทพประกันชีวิต'
    }
  },
  {
    path: '/FinishVerification',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishVerification',
      component: FinishVerificationView
    }],
    meta: {
      title: 'FinishVerification'
    }
  },
  {
    path: '/FinishSendAdditionalDoc',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishSendAdditionalDoc',
      component: FinishSendAdditionalDocView
    }],
    meta: {
      title: 'FinishSendAdditionalDoc'
    }
  },
  {
    path: '/ProspectHistoryDetail',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'ProspectHistoryDetail',
      component: ProspectHistoryDetail
    }],
    meta: {
      title: 'ProspectHistoryDetail'
    }
  },
  {
    path: '/AgentRenewLicense',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'AgentRenewLicense',
      component: AgentRenewLicenseView
    }],
    meta: {
      title: 'ขอต่ออายุใบอนุญาต'
    }
  },
  {
    path: '/PreviewAgentRenewLicense',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'PreviewAgentRenewLicense',
      component: PreviewAgentRenewLicense
    }],
    meta: {
      title: 'ตรวจสอบข้อมูลผู้ยื่นคำร้อง'
    }
  },
  {
    path: '/Tc7Certification',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'Tc7Certification',
      component: Tc7Certification
    }],
    meta: {
      title: 'อ่านคำรับรองคุณสมบัติ ตช.7 และรับรองคุณสมบัติ'
    }
  },
  {
    path: '/UploadFileAgentRenewLicense',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'UploadFileAgentRenewLicense',
      component: UploadFileAgentRenewLicense
    }],
    meta: {
      title: 'อัปโหลดเอกสาร'
    }
  },
  {
    path: '/ReviewDraftAgentRenewLicense',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'ReviewDraftAgentRenewLicense',
      component: ReviewDraftAgentRenewLicense
    }],
    meta: {
      title: 'ตรวจสอบความถูกต้องของแบบร่างคำรับรองคุณสมบัติ ตช.7 และแบบฟอร์มต่อทะเบียนตัวแทน Unit Linked'
    }
  },
  {
    path: '/OTPVerifyAgentRenewLicense',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'OTPVerifyAgentRenewLicense',
      component: OTPVerifyAgentRenewLicense
    }],
    meta: {
      title: 'SMS OTP'
    }
  },
  {
    path: '/CheckPaymentAgentRenewLicense',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'CheckPaymentAgentRenewLicense',
      component: CheckPaymentAgentRenewLicense
    }],
    meta: {
      title: 'ตรวจสอบการชำระค่าต่ออายุใบอนุญาต'
    }
  },
  {
    path: '/FinishAgentRenewLicense',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishAgentRenewLicense',
      component: FinishAgentRenewLicense
    }],
    meta: {
      title: 'Thank You'
    }
  },
  {
    path: '/AgentRenewLicenseAdditionalDoc',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'AgentRenewLicenseAdditionalDoc',
      component: AgentRenewLicenseAdditionalDocView
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม ยื่นขอต่ออายุใบอนุญาต'
    }
  },
  {
    path: '/FinishSendAgentRenewLicenseAdditionalDoc',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishSendAgentRenewLicenseAdditionalDoc',
      component: FinishSendAgentRenewLicenseAdditionalDoc
    }],
    meta: {
      title: 'Thank You'
    }
  },
  {
    path: '/ChangeNameEN',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'ChangeNameEN',
      component: ChangeNameEN
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม ขอเปลี่ยนแปลงข้อมูล ชื่อ - นามสกุล (ภาษาอังกฤษ)'
    }
  },
  {
    path: '/ChangeAddr',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'ChangeAddr',
      component: ChangeAddr
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม ขอเปลี่ยนแปลงข้อมูล ที่อยู่'
    }
  },
  {
    path: '/ChangeAccBank',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'ChangeAccBank',
      component: ChangeAccBank
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม ขอเปลี่ยนแปลงข้อมูล บัญชีธนาคาร'
    }
  },
  {
    path: '/ChangeVat',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'ChangeVat',
      component: ChangeVat
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม ขอเปลี่ยนแปลงข้อมูล บันทึก VAT'
    }
  },
  {
    path: '/FinishAdditionalDocsPage',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'FinishAdditionalDocsPage',
      component: FinishAdditionalDocsPage
    }],
    meta: {
      title: 'Thank You'
    }
  },
  {
    path: '/AppointOperationExecutive',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'AppointOperationExecutive',
      component: AppointOperationExecutive
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม ขอแต่งตั้งตำแหน่ง(ผู้บริหารหน่วยดำเนินการ)'
    }
  },
  {
    path: '/OperationExecutivePromotion',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'OperationExecutivePromotion',
      component: OperationExecutivePromotion
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม ขอเปลี่ยนแปลงตำแหน่ง(ผู้บริหารหน่วยดำเนินการ)'
    }
  },
  {
    path: '/OperationExecutiveDowngrade',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'OperationExecutiveDowngrade',
      component: OperationExecutiveDowngrade
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม ขอเปลี่ยนแปลงตำแหน่ง(ผู้บริหารหน่วยดำเนินการ)'
    }
  },
  {
    path: '/TransferSubAgentOperationExecutive',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'TransferSubAgentOperationExecutive',
      component: TransferSubAgentOperationExecutive
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม ขอโอนตัวแทนใต้สังกัด(ผู้บริหารหน่วยดำเนินการ)'
    }
  },
  {
    path: '/BranchTransferOperationExecutive',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'BranchTransferOperationExecutive',
      component: BranchTransferOperationExecutive
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม แจ้งย้ายสาขา(ผู้บริหารหน่วยดำเนินการ)'
    }
  },
  {
    path: '/BranchTransferOperationAgent',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'BranchTransferOperationAgent',
      component: BranchTransferOperationAgent
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม ขอย้ายสาขา(ตัวแทนดำเนินการ)'
    }
  },
  {
    path: '/TransferPerformance',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'TransferPerformance',
      component: TransferPerformance
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม ขอโอนผลงาน'
    }
  },
  {
    path: '/ReqAgentCertTH',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'ReqAgentCertTH',
      component: ReqAgentCertTH
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม ขอหนังสือรับรองการทำงานภาษาไทย'
    }
  },
  {
    path: '/ReqAgentCertENNoIncome',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'ReqAgentCertENNoIncome',
      component: ReqAgentCertENNoIncome
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม ขอหนังสือรับรองการทำงานภาษาอังกฤษ (แบบไม่ระบุรายได้)'
    }
  },
  {
    path: '/ReqAgentCertENIncome2Years',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'ReqAgentCertENIncome2Years',
      component: ReqAgentCertENIncome2Years
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม ขอหนังสือรับรองการทำงานภาษาอังกฤษ (ระบุรายได้ของปีนี้ และปีที่แล้ว)'
    }
  },
  {
    path: '/ReqAgentCertENIncomeCurrent',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'ReqAgentCertENIncomeCurrent',
      component: ReqAgentCertENIncomeCurrent
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม ขอหนังสือรับรองการทำงานภาษาอังกฤษ (ระบุรายได้เฉพาะของปีนี้)'
    }
  },
  {
    path: '/ReqAgentBusinessCard',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'ReqAgentBusinessCard',
      component: ReqAgentBusinessCard
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม ขอพิมพ์นามบัตร'
    }
  },
  {
    path: '/ReqAgentResignation',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'ReqAgentResignation',
      component: ReqAgentResignation
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม ขอลาออก'
    }
  },
  {
    path: '/BuildingAccessCard',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'BuildingAccessCard',
      component: BuildingAccessCard
    }],
    meta: {
      title: 'ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน'
    }
  },
  {
    path: '/CardRequestType',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'CardRequestType',
      component: CardRequestType
    }],
    meta: {
      title: 'ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน'
    }
  },
  {
    path: '/BACUploadFile',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'BACUploadFile',
      component: BACUploadFile
    }],
    meta: {
      title: 'ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน'
    }
  },
  {
    path: '/BACPayment',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'BACPayment',
      component: BACPayment
    }],
    meta: {
      title: 'ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน'
    }
  },
  {
    path: '/BACSuccess',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'BACSuccess',
      component: BACSuccess
    }],
    meta: {
      title: 'ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน'
    }
  },
  {
    path: '/BACAdditionalDoc',
    component: FrontendLayout,
    children: [{
      path: '',
      name: 'BACAdditionalDoc',
      component: BACAdditionalDoc
    }],
    meta: {
      title: 'ส่งเอกสารเพิ่มเติม ขอทำบัตรประจำตัวผ่านเข้าออกอาคารสำนักงาน'
    }
  },
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router